// ═══════════════════════════════════════════════════════════════
// ActiveJobBanner — thin sticky strip across the top of every
// authenticated screen whenever any job is currently running
// (startedAt set, no closedAt, not awaiting return). Tap to jump
// back into /active/:jobId.
//
// Hidden on the active workspace itself (would be redundant) and
// when no job is running. Multi-running-jobs is treated as "first
// one wins" for v0.1 — finding more than one running shouldn't
// happen in normal use anyway (Start clears awaitingReturn but
// doesn't touch other jobs).
// ═══════════════════════════════════════════════════════════════
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useUserData } from './lib/use-user-data.js';
import { isRunning } from './lib/job-helpers.js';

export default function ActiveJobBanner() {
  const { jobs, allCustomers } = useUserData();
  const location = useLocation();

  // Don't double up on the active workspace itself
  const onActiveScreen = location.pathname.startsWith('/active/');

  const runningJob = useMemo(() => jobs.find(isRunning), [jobs]);

  if (onActiveScreen) return null;
  if (!runningJob)    return null;

  const customer = allCustomers.find((c) => c.id === runningJob.customerId);

  return (
    <Link to={`/active/${runningJob.id}`} className="active-job-banner" aria-label="Resume active job">
      <span className="active-job-banner-pulse" aria-hidden />
      <span className="active-job-banner-label">On the job:</span>
      <strong className="active-job-banner-name">
        {customer?.name || 'Customer'}
      </strong>
      <span className="active-job-banner-cta">
        Resume <ChevronRight size={14} />
      </span>
    </Link>
  );
}
